<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    <div class="right-menu">
      <!-- 认证状态 客户端-->
      <!-- <div class="auth" v-if="isAdmin == false" @click.stop="Authstatus"> -->
        <!-- <div class="no" v-if="auth == 1">
          <svg-icon icon-class="auth_never"></svg-icon>
          未认证
        </div>
        <div class="checking" v-else-if="auth == 2">
          <svg-icon icon-class="auth_checking"></svg-icon>
          审核中
        </div>
        <div class="failure" v-else-if="auth == 3">
          <svg-icon icon-class="auth_never"></svg-icon>
          认证失败
        </div>
        <div class="success" v-else-if="auth == 4">
          <svg-icon icon-class="auth_success"></svg-icon>
          已认证
        </div> -->
<!-- 
        <div class="checking" v-if="isAuth == 'WAITING'">
          <svg-icon icon-class="auth_checking"></svg-icon>
          审核中
        </div>
        <div class="failure" v-else-if="isAuth == 'DENY'">
          <svg-icon icon-class="auth_never"></svg-icon>
          认证失败
        </div>
        <div class="failure" v-else-if="isAuth == 'PLATFORM_DENY'">
          <svg-icon icon-class="auth_never"></svg-icon>
          平台驳回
        </div>
        <div class="success" v-else-if="isAuth == 'PLATFORM_PASS'">
          <svg-icon icon-class="auth_success"></svg-icon>
          已认证
        </div>
        <div class="checking" v-else-if="isAuth == 'PASS'">
          <svg-icon icon-class="auth_checking"></svg-icon>
          移动平台审核中
        </div>
        <div class="no" v-else>
          <svg-icon icon-class="auth_never"></svg-icon>
          未认证
        </div>
      </div> -->
      <!-- 头像 -->
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <img
            :src="user.avatar || require('@/assets/other/avatar_holder.png')"
            class="user-avatar"
          />
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link :to="userinfoPath">
            <el-dropdown-item> 个人资料 </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
export default {
  components: {
    Breadcrumb,
    Hamburger,
  },
  data() {
    return {
      auth: "", // 认证状态
      userauth: this.$store.getters.authkey,
    };
  },
  computed: {
    ...mapGetters(["sidebar", "user", "device"]),
    userinfoPath() {
      return this.isAdmin ? "/system/info" : "/info/index";
    },
    loginPath() {
      return this.isAdmin ? "/login" : "/userLogin";
    },
    isAdmin() {
      return this.user.role === "admin";
    },
    isAuth() {
      return this.$store.getters.user.auth;
    },
  },
  mounted() {
    this.getAuthkey();
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    // 认证资料状态
    async getAuthkey() {
      const that = this;
      await this.$store.dispatch("getAuthkey");
      const Authkey = localStorage.getItem("Authkey");
      this.$nextTick(() => {
        if (Authkey == "DEFAULT" || Authkey == "WAITING") {
          that.auth = 2;
        } else if (Authkey == "DENY") {
          that.auth = 3;
        } else if (Authkey == "PASS") {
          that.auth = 4;
        } else {
          that.auth = 1;
        }
      });
    },
    // 状态管理页面
    Authstatus() {
      this.$router.push({ path: "/authinfo/info" });
    },
    // 退出登录
    async logout() {
      await this.$store.dispatch("user/logout");
      localStorage.clear();
      this.$router.push({ path: "/login" });
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 48px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 21, 41, 0.1);
  margin-bottom: 2px;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;
    justify-content: right;

    .auth {
      height: 30px;
      display: flex;
      font-size: 11px;
      cursor: pointer;

      .no,
      .failure,
      .checking,
      .success {
        height: 100%;
        display: flex;
        align-items: center;
        padding: 0px 5px;
        border-radius: 3px;
        margin-right: 5px;

        .svg-icon {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
      }

      .no,
      .failure {
        color: #fbaaaa;
        border: 1.5px solid #fbaaaa;
      }

      .checking {
        color: #ff9900;
        border: 1.5px solid #ff9900;
      }

      .success {
        color: #19be6b;
        border: 1.5px solid #19be6b;
      }
    }

    &:focus {
      outline: none;
    }

    .authStatus {
      width: 80px;
      height: auto;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 15px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
